import type { AlertDto } from "@nabla/api";

export function createAlerts(touch: (topic: string) => void) {
  const alerts = new Map<string, AlertDto>();
  let list: readonly AlertDto[] | undefined;
  return {
    put(alert: AlertDto): void {
      alerts.set(alert.id, alert);
      list = undefined;
      touch("alerts");
    },
    list: () => (list ??= [...alerts.values()]),
    clear(between: () => void): void {
      alerts.clear();
      between();
      list = undefined;
    },
  };
}
